import React from "react"
import { Link } from "react-router-dom"
import { Button, Col, Container, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { Layout } from "../../components/layout"
import { Head } from "../../components/seo"

export const ApplicationSubmittedPage = () => {
  const { t } = useTranslation("translations", { keyPrefix: "EMPLOYMENT.APPLICATION_SUBMITTED" })
  return (
    <Layout title={t("TITLE")} subtitle={t("SUBTITLE")}>
      <Head title={t("TITLE")} />
      <Container className="text-center">
        <div className="my-5">
          <h5 className="my-3">{t("MESSAGE")}</h5>
        </div>
        <Row className="justify-content-center">
          <Col md={4}>
            <Link to="/" style={{ textDecoration: "none" }}>
              <Button variant="outline-dark" className="rounded-0 mb-4 w-100">{t("BUTTON_BACK")}</Button>
            </Link>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}
